import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a365d] text-white py-8" data-id="element-33">
      <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-34">
        <p className="text-sm mb-2" data-id="element-35">© 2026 De Psicólogo a RRHH</p>
        <p className="text-xs text-gray-400" data-id="element-36">
          Este sitio no forma parte de Meta ni está afiliado a sus plataformas.
        </p>
      </div>
    </footer>;
}